import Papa from "papaparse";

// ✅ حط رابط CSV تبع الشيت الجديد (pub?output=csv)
const GOOGLE_SHEET_URL =
  "https://docs.google.com/spreadsheets/d/e/2PACX-1vRNzcb5ECJ-p-skAD7rcmhJ_by9ySiHbbi4Z4egUA7hIn3lZqBXnehKJPSAGF5MQAxB9w71Y0KfEDgL/pub?gid=1122801609&single=true&output=csv";

// مثال: "JOD6.30" -> 6.30
const parseJod = (v) => {
  const s = String(v ?? "").trim();
  const num = parseFloat(s.replace(/[^0-9.]/g, ""));
  return Number.isFinite(num) ? num : 0;
};

// بعض الأحيان اسم عمود السعر يطلع مختلف/مقصوص
const findPriceKey = (headers = []) => {
  return (
    headers.find((h) => h === "product/retailPrice/amountWithSymbol") ||
    headers.find((h) => String(h).startsWith("product/retailPrice")) ||
    headers.find((h) => String(h).startsWith("product/retailPri")) ||
    null
  );
};

export const dataProvider = {
  getList: () =>
    new Promise((resolve, reject) => {
      const url = `${GOOGLE_SHEET_URL}&_t=${Date.now()}`; // cache bust

      Papa.parse(url, {
        download: true,
        header: true,
        skipEmptyLines: true,
        complete: (results) => {
          const rows = results.data || [];
          const headers = results.meta?.fields || [];
          const priceKey = findPriceKey(headers);

          const data = rows
            .filter((r) => r["product/goods_name"]) // لازم اسم منتج
            .map((r, index) => {
              const title = r["product/goods_name"] || "";
              const category = (r["product/cate_name"] || "General").trim();
              const image = r["product/detail_image/0"] || "";
              const slug = r["product/goods_url_name"] || "";

              const priceRaw = priceKey ? r[priceKey] : "";
              const price = parseJod(priceRaw);

              // id لازم يكون unique (num مكرر عندك)
              const id = `${index}_${slug || "x"}`;

              // رابط مضمون: بحث Google بالاسم
              const url = `https://www.google.com/search?q=${encodeURIComponent(title)}`;

              return {
                id,
                title,
                category,
                image,
                price, // رقم
                url,
                sizes: "",
                colors: "",
                description: "",
              };
            });

          resolve({ data, total: data.length });
        },
        error: (err) => reject(err),
      });
    }),

  getOne: (resource, params) =>
    dataProvider.getList(resource).then(({ data }) => ({
      data: data.find((x) => String(x.id) === String(params.id)),
    })),
};
